function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoinlist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 560 400",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "matrix(0.650195,0,0,0.647059,30,167)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CoinList-white",
    transform: "matrix(1,0,0,1,0,22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "matrix(1,0,0,1,78,0.2003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-1-Clipped"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    d: "M9.051,7.176C7.961,7.176 7.074,8.063 7.074,9.153L7.074,47.409C7.074,48.499 7.961,49.386 9.051,49.386L45.7,49.386C46.79,49.386 47.676,48.499 47.676,47.409L47.676,9.153C47.676,8.063 46.79,7.176 45.7,7.176L9.051,7.176ZM45.7,55.763L9.051,55.763C4.445,55.763 0.697,52.015 0.697,47.409L0.697,9.153C0.697,4.547 4.445,0.799 9.051,0.799L45.7,0.799C50.306,0.799 54.053,4.547 54.053,9.153L54.053,47.409C54.053,52.015 50.306,55.763 45.7,55.763Z",
    style: {
      fill: "rgb(34,34,38)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    d: "M448.205,56.059L409.693,56.059L409.693,49.682L448.205,49.682C449.295,49.682 450.182,48.796 450.182,47.706L450.182,33.349C450.182,32.259 449.295,31.373 446.089,31.373L415.827,31.373C413.339,31.373 409.592,27.625 409.592,23.02L409.592,9.45C409.592,4.843 413.339,1.096 417.943,1.096L454.88,1.096L454.88,7.473L417.943,7.473C416.854,7.473 415.969,8.36 415.969,9.45L415.969,23.02C415.969,24.11 416.854,24.997 417.943,24.997L448.205,24.997C452.811,24.997 456.559,28.744 456.559,33.349L456.559,47.706C456.559,52.312 452.811,56.059 448.205,56.059",
    style: {
      fill: "rgb(34,34,38)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-6",
    d: "M337.063,56.048L295.023,56.048L295.023,1.094L301.4,1.094L301.4,49.671L337.063,49.671L337.063,56.048Z",
    style: {
      fill: "rgb(34,34,38)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-8",
    d: "M254.121,56.039L214.575,10.727L214.575,56.097L208.198,56.097L208.198,1.09L214.628,1.09L255.175,47.542L255.17,1.095L261.547,1.095L261.553,56.039L254.121,56.039Z",
    style: {
      fill: "rgb(34,34,38)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Fill-10-Clipped",
    transform: "matrix(1,0,0,1,0,1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Fill-10",
    x: 166.929,
    y: 0.095,
    width: 6.404,
    height: 54.963,
    style: {
      fill: "rgb(34,34,38)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-12-Clipped",
    transform: "matrix(1,0,0,1,0,1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Fill-12",
    x: 367.691,
    y: 0.089,
    width: 6.404,
    height: 54.964,
    style: {
      fill: "rgb(34,34,38)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-13-Clipped",
    transform: "matrix(1,0,0,1,0,1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-13",
    d: "M534.988,0.098L512.535,0.098L512.535,0.089L506.132,0.089L506.132,0.098L483.678,0.098L483.678,6.501L506.132,6.501L506.132,55.058L512.535,55.058L512.535,6.501L534.988,6.501L534.988,0.098Z",
    style: {
      fill: "rgb(34,34,38)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-14-Clipped",
    transform: "matrix(1,0,0,1,0,1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-14",
    d: "M47.013,54.963L8.353,54.963C3.747,54.963 0,51.215 0,46.609L0,8.353C0,3.747 3.747,-0.001 8.353,-0.001L47.013,-0.001L47.013,6.376L8.353,6.376C7.263,6.376 6.377,7.263 6.377,8.353L6.377,46.609C6.377,47.699 7.263,48.586 8.353,48.586L47.013,48.586L47.013,54.963Z",
    style: {
      fill: "rgb(34,34,38)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    d: "M769,19C769,8.514 760.486,0 750,0L601,0C590.514,0 582,8.514 582,19L582,83C582,93.486 590.514,102 601,102L750,102C760.486,102 769,93.486 769,83L769,19Z",
    style: {
      fill: "rgb(216,216,216)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,620.42,70)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PRO"
  }, /*#__PURE__*/React.createElement("text", {
    x: "0px",
    y: "0px",
    style: {
      fontFamily: "'Arial-BoldMT', 'Arial', sans-serif",
      fontWeight: 700,
      fontSize: 56
    }
  }, "PRO")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinlist);
export default __webpack_public_path__ + "static/media/coinlist.c8f6b9e25aa65079f35e1fa6afd845b5.svg";
export { ForwardRef as ReactComponent };